/**
 * 用户token
 *
 * @format
 */

export const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN';

/** 重定向 */
export const REDIRECT_URI_KEY = 'REDIRECT_URI';

/** 国际化 */
export const LOCALE_KEY = 'LOCALE__';

/** 主题色 */
export const THEME_KEY = 'THEME__';

/** 用户信息 */
export const USER_INFO_KEY = 'USER__INFO__';

// role info key
export const ROLES_KEY = 'ROLES__KEY__';
/** 是否锁屏 */
export const IS_LOCKSCREEN = 'IS_LOCKSCREEN';
/** 标签页 */
export const TABS_ROUTES = 'TABS_ROUTES';

// CAS 单点登录token
export const JESSIONID = 'JESSIONID';

// 门户token
export const ADMIN_TOKEN = 'Admin-Token';
